import firstImage from "../assets/first.png";
import secondImage from "../assets/sec.png";
import thirdImage from "../assets/third.png";
import four from "../assets/fourth.png";
import five from "../assets/fifth.png";
import frame1 from "../assets/frame1.jpg";
import frame2 from "../assets/frame2.jpg";
import frame3 from "../assets/frame3.jpg";
import frame4 from "../assets/frame4.jpg";
import frame5 from "../assets/frame5.jpg";
import frame6 from "../assets/frame6.jpg";
import rect1 from "../assets/rect1.png";
import rect2 from "../assets/rect2.png";
import rect3 from "../assets/rect3.png";
import rect4 from "../assets/rect4.png";
import rect5 from "../assets/rect5.png";
import rect6 from "../assets/rect6.png";
import video1 from "../assets/video1.png";
import video2 from "../assets/video2.png";
import video3 from "../assets/video3.png";
import video4 from "../assets/video4.png";
import video5 from "../assets/video5.png";

const gratitude = {
  title1: "Gratitude",
  word1: "Journal all the things you are thankful for and share your joy.",
  image1: firstImage,
};
const affirmation = {
  title2: "Affirmation",
  word2: "Start your day with powerful words of affirmation.",
  image2: secondImage,
};
const plan = {
  title3: "Plan Your Day",
  word3: "Organise all your to-do list with our effective planner feature.",
  image3: thirdImage,
};
const fourth = {
  image1: four,
  image2: five,
};
const images = {
  frame1,
  frame2,
  frame3,
  frame4,
  frame5,
  frame6,
};
const videoImages = {
  video1,
  video2,
  video3,
  video4,
  video5,
};
const affirmationDetails = [
  {
    quote: "I have more than enough",
    image: rect1
  },
  {
    quote: "I have more than enough 2",
    image: rect2
  },
  {
    quote: "I have more than enough 3",
    image: rect3
  },
  {
    quote: "I have more than enough 4",
    image: rect4
  },
  {
    quote: "I have more than enough 5",
    image: rect5
  },
  {
    quote: "I have more than enough 6",
    image: rect6
  },
]

export default { gratitude, affirmation, plan, fourth, images, videoImages, affirmationDetails };
